// Phones: a "View buying options" control appears once the Add to basket button has scrolled
// above the screen, and jumps back to the price and buying details (#mx-buy).
(() => {
  const link = document.querySelector('[data-mx-buy-jump]');
  const buyButtons = document.querySelector('.product-information .buy-buttons-block');
  if (!link || !buyButtons || !('IntersectionObserver' in window)) return;

  new IntersectionObserver(([entry]) => {
    link.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
  }).observe(buyButtons);

  link.addEventListener('click', () => {
    // Move focus with the jump so keyboard and screen-reader users land on the buying details.
    requestAnimationFrame(() => document.getElementById('mx-buy')?.focus({ preventScroll: true }));
  });
})();
